import {FITH2Symbol, ISymbolData, FITH2SymbolStates} from "./FITH2Symbol";
import {gsap} from "gsap";
import {FireInTheHole2} from "../FireInTheHole2";
import {SpineTween} from "@nolimit/slot-game/bin/animation/SpineTween";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {ScatterCounter} from "../view/ScatterCounter";

export class FITH2Scatter extends FITH2Symbol {
    private _isPlayingTrigger: boolean;
    private _isPlayingAttention: boolean;
    private _currentAnimation: string;
    private _isAdded: boolean;

    constructor(symbolData: ISymbolData, state: FITH2SymbolStates = FITH2SymbolStates.NORMAL) {
        super(symbolData);
        this._isPlayingTrigger = false;
        this._isPlayingAttention = false;
        this._currentAnimation = "base";
        this._spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("S"));
        this._isAdded = false;
        if (!this.isBehindDirt) {
            this.addChild(this._spine);
            this._currentStateSprite.visible = false;
            this._spine.state.setAnimation(0, "base", false);
        }
    }

    private set isPlayingAttention(value: boolean) {
        if (this._isPlayingAttention) {
            return;
        }
        if (!this.parent) {
            debugger;
        }
        this.parent.removeChild(this);
        FireInTheHole2.reelArea.allReels[this.reelId].reelView.scatterWinView.addChild(this);
        this._isPlayingAttention = true;
    }

    protected removeDirt(fromSplit: boolean = true): gsap.core.Timeline {
        return super.removeDirt(fromSplit).add(() => {
            this._currentStateSprite.visible = false;
            this.addChild(this._spine!);
            this._spine!.state.setAnimation(0, this._currentAnimation, true);
            if(!this._isAdded){
                ScatterCounter.addScatter(this);
            }
        });
    }

    public playLandingAnimation(): gsap.core.Timeline {
        return gsap.timeline().add(new SpineTween(this._spine!, 0, "land"));
    }

    public playWin(): gsap.core.Timeline {
        this._isPlayingTrigger = true;
        this._currentAnimation = "base";
        return gsap.timeline().add(() => {
            this._spine!.state.setEmptyAnimation(0, 0);
        }).add(new SpineTween(this._spine!, 0, "land_win"));
    }

    public playForthScatter(): gsap.core.Timeline {
        this._currentAnimation = "scatter3";
        return gsap.timeline().add([
            new SpineTween(this._spine!, 0, "land_win_extra"),
            () => {
                this._isPlayingAttention = true;
                FITH2SoundManager.playScatterLandExtraSound();
            }
        ]);
    }

    public playScatterAttention(): gsap.core.Timeline {

        this._currentAnimation = "anticipation";
        return gsap.timeline().add(() => {
            this.isPlayingAttention = true;
            this._spine!.state.setAnimation(0, "anticipation", true)
        });
    }

    public playThirdScatterLanding(): gsap.core.Timeline {
        this._currentAnimation = "scatter3";
        return gsap.timeline().add([
            new SpineTween(this._spine!, 0, "land_win"),
            () => {
                FITH2SoundManager.playSound("scatter3");
            }
        ]);
    }

    public playThirdScatter(): gsap.core.Timeline {
        this._currentAnimation = "scatter3";
        return gsap.timeline().add([
            () => {
                this._isPlayingAttention = true;
                this._spine!.state.setEmptyAnimation(0, 0);
                if(!this._isPlayingTrigger){
                    this._spine!.state.setAnimation(0, "scatter3", true);
                }
            }
        ]);

    }

    public stopAnimation(fsWon: boolean): void {
        if (!fsWon) {
            this._currentAnimation = "base";
            this._isPlayingAttention = false;
            this._spine!.state.setAnimation(0, "base", false);
        }
    }

    public setRestoreState(): void {
        this._currentAnimation = "base";
    }

    public set isAdded(value: boolean) {
        this._isAdded = value;
    }

    public setRestoreState2(i: number): void {
        this.isPlayingAttention = true;
        this._currentAnimation = "anticipation";
    }
}